import './CurrentQuestion.scss'
import React from 'react'
import { observer } from 'mobx-react'
import { OneToTenInput } from './question'

const CurrentQuestion = ({ question, answered, onChange, onAnswer, onNext }) => {
  const Input = question.component || OneToTenInput
  return (
    <div className='CurrentQuestion'>
      <h3>{question.title}</h3>
      {question.description && (
        <p>{question.description}</p>
      )}
      <Input
        label={question.label}
        placeholder={question.placeholder}
        value={question.value}
        onChange={onAnswer}
        onEnter={onNext}
      />
    </div>
  )
}

CurrentQuestion.displayName = 'CurrentQuestion'

export default observer(CurrentQuestion)



// WEBPACK FOOTER //
// ./src/assess/CurrentQuestion.js